// removed by extract-text-webpack-plugin
module.exports = {"shareContainer":"_1IbK3yBnHFG4BM5njMmh_m","linkText":"_2z3nhSdFUkFPe_OJta8P0X","copyBtn":"_2q9REisYIqx9O3BBiIK8ac"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/shareLink/shareLink.scss
// module id = 442
// module chunks = 0